import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

// Ajout du CDN Bootstrap Icons si pas déjà présent
if (!document.querySelector('link[href*="bootstrap-icons"]')) {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.0/font/bootstrap-icons.css';
  document.head.appendChild(link);
}

const CACIChatbot = () => {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [showNotification, setShowNotification] = useState(true);
  const [conversationHistory, setConversationHistory] = useState([]); // تعريف متغير الـ conversation history
  const messagesEndRef = useRef(null);

  // Configuration API Groq
  const AI_CONFIG = {
    provider: 'groq',
    apiKey: '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',
    endpoint: 'https://api.groq.com/openai/v1/chat/completions',
    model: 'llama3-8b-8192'
  };

  // دالة للحصول على اللغة الحالية
  const getCurrentLanguage = () => {
    return i18n.language || 'fr';
  };

  // دالة للتعرف على الدارجة الجزائرية
  const isDarija = (text) => {
    const darijaWords = [
      'واش', 'كيفاش', 'شحال', 'برك', 'بصح', 'صحيح', 'علاش', 'وين', 'شكون', 'وقتاش',
      'كي', 'حنا', 'انتوما', 'هوما', 'راني', 'راك', 'راها', 'راهم', 'نحب', 'تحب',
      'يحب', 'ماشي', 'خلاص', 'ياسر', 'قاع', 'والو', 'فايت', 'لوقت', 'مليح', 'باهي',
      'هكذا', 'كيما', 'قولولي', 'قول لي', 'شوية', 'تع', 'نتاع', 'بزاف', 'ما راني عارف',
      'ما رانيش', 'شوف', 'انشوف', 'نروح', 'نجي', 'نخدم', 'حاجة', 'حوايج', 'بيها',
      'معاها', 'فيها', 'ليها', 'عليها', 'يالاه', 'هيا', 'وش', 'كاش', 'تاني', 'زادة'
    ];
    
    return darijaWords.some(word => text.includes(word));
  };

  // CACI context for AI responses (مع إضافة فهم الدارجة والرد بالفصحى)
  const caciContext = `Tu es un assistant IA pour la Chambre Algérienne de Commerce et d'Industrie (CACI).

  INSTRUCTIONS CRITIQUES:
  1. SEULEMENT répondre aux questions liées à la CACI, commerce, industrie, services aux entreprises, ou économie algérienne
  2. Si on te pose des questions non liées (météo, actualités, politique, autres sujets), redirige poliment vers les sujets CACI
  3. RÈGLES LINGUISTIQUES IMPORTANTES:
     - Si l'utilisateur pose une question en français, réponds en français
     - Si l'utilisateur pose une question en anglais, réponds en anglais
     - Si l'utilisateur pose une question en arabe classique, réponds en arabe classique
     - Si l'utilisateur pose une question en darija (dialecte algérien), réponds en arabe classique (فصحى)
  4. Garde les réponses concises et utiles (2-3 phrases maximum)
  5. Encourage toujours le contact ou la visite quand approprié

  RECONNAISSANCE DE LA DARIJA ALGÉRIENNE (pour comprendre mais répondre en arabe classique):
  Mots et expressions typiques de la darija: واش، كيفاش، شحال، برك، بصح، صحيح، علاش، وين، شكون، وقتاش، كي، حنا، انتوما، هوما، راني، راك، راها، راهم، نحب، تحب، يحب، ماشي، خلاص، ياسر، قاع، والو، فايت، لوقت، مليح، باهي، هكذا، كيما، قولولي، قول لي، شوية، تع، نتاع، بزاف، ما راني عارف، ما رانيش، شوف، انشوف، نروح، نجي، نخدم، حاجة، حوايج

  À PROPOS DE LA CACI:
  - الاسم: الغرفة الجزائرية للتجارة والصناعة (CACI)
  - Mission: Représenter les intérêts des entreprises en Algérie et promouvoir le développement économique national
  - العنوان: القصر القنصلي 6 شارع أميلكار كابرال، ساحة الشهداء، الجزائر العاصمة
  - التلفون: 023161631 / 023160534 / 023161489
  - الايميل: infos-caci@caci.dz

  SERVICES PRINCIPAUX:
  - مساعدة إدارية وقانونية للشركات
  - قاعدة بيانات اقتصادية
  - وساطة وتحكيم تجاري
  - استشارة ومرافقة الشركات
  - تنظيم فعاليات اقتصادية
  - تكوين مهني
  - تصديق ومصادقة الوثائق

  PLATEFORMES CACI:
  - ElMouchir (elmouchir.caci.dz) - المشير دليل الشركات
  - EC (ec.caci.dz) - التجارة الإلكترونية
  - BC (bc.caci.dz) - مركز الأعمال
  - Formations (formations.caci.dz) - التكوين
  - Sanist (sanist.dz) - الحلول الصحية
  - Logistical (logistical.dz) - الحلول اللوجستية
  - Liccal (liccal.caci.dz) - التراخيص التجارية
  - Bourse (bourse.caci.dz) - بورصة التجارة
  - B2B (b2b.caci.dz) - منصة الأعمال

  EXEMPLES DE RÉPONSES:

  Questions en français → Réponses en français:
  "Quels sont vos services?" → "La CACI offre assistance administrative, médiation commerciale, base de données économiques et formation professionnelle! 📋 Contactez-nous au 023161631 pour plus d'informations!"

  Questions en darija → Réponses en arabe classique:
  "واش عندكم خدمات؟" → "تقدم الغرفة الجزائرية للتجارة والصناعة خدمات متنوعة: المساعدة الإدارية والقانونية، قاعدة البيانات الاقتصادية، الوساطة والتحكيم التجاري، والتكوين المهني. 📋 اتصلوا بنا على الرقم 023161631 للمزيد من المعلومات!"
  
  "شحال الخدمة؟" → "تختلف الأسعار حسب نوع الخدمة المطلوبة. 💰 نقدم خيارات مناسبة لجميع الميزانيات. يرجى الاتصال بنا على 023161631 للحصول على تفاصيل الأسعار!"
  
  "وين راكم؟" → "يقع مقر الغرفة الجزائرية للتجارة والصناعة في القصر القنصلي، 6 شارع أميلكار كابرال، ساحة الشهداء، الجزائر العاصمة. 📍 هاتف: 023161631 / 023160534 📞 بريد إلكتروني: infos-caci@caci.dz ✉️"
  
  "كيفاش نخدم معاكم؟" → "يمكنكم الاستفادة من خدماتنا بالطرق التالية: 1️⃣ الاتصال بنا على 023161631 2️⃣ زيارة مكاتبنا في القصر القنصلي 3️⃣ تصفح منصاتنا الإلكترونية. فريقنا مستعد لخدمتكم! 🤝"

  Questions en arabe classique → Réponses en arabe classique:
  "ما هي خدماتكم؟" → "تقدم الغرفة الجزائرية للتجارة والصناعة المساعدة الإدارية والوساطة التجارية وقاعدة البيانات الاقتصادية والتكوين المهني! 📋 اتصلوا بنا على 023161631 للمزيد من المعلومات!"

  Questions non liées - Redirection:
  "واش الطقس مليح؟" → "أنا هنا لمساعدتكم في أمور الغرفة الجزائرية للتجارة والصناعة فقط! 😊 هل تودون معرفة معلومات عن خدماتنا أو منصاتنا الإلكترونية؟"
  `;

  // Appel API Groq avec historique de conversation
  const callGroqAPI = async (message) => {
    try {
      // Construire l'historique des messages pour le contexte
      const conversationMessages = [
        { role: 'system', content: caciContext }
      ];

      // Ajouter l'historique récent (limité aux 10 derniers échanges pour éviter de dépasser les limites)
      const recentHistory = conversationHistory.slice(-10);
      recentHistory.forEach(item => {
        conversationMessages.push({ role: 'user', content: item.user });
        conversationMessages.push({ role: 'assistant', content: item.assistant });
      });

      // Ajouter le message actuel
      conversationMessages.push({ role: 'user', content: message });

      const response = await fetch(AI_CONFIG.endpoint, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${AI_CONFIG.apiKey}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          model: AI_CONFIG.model,
          messages: conversationMessages,
          max_tokens: 300, // Augmenté pour des réponses plus détaillées
          temperature: 0.7,
          // Paramètres pour améliorer la cohérence
          frequency_penalty: 0.1,
          presence_penalty: 0.1
        })
      });
      
      if (!response.ok) {
        throw new Error(`API Error: ${response.status}`);
      }
      
      const data = await response.json();
      const aiResponse = data.choices[0].message.content;

      // Mettre à jour l'historique de conversation
      setConversationHistory(prev => [
        ...prev,
        { user: message, assistant: aiResponse, timestamp: new Date() }
      ]);

      return aiResponse;
    } catch (error) {
      console.error('Groq API Error:', error);
      // Fallback en cas d'erreur API
      return generateSmartResponse(message);
    }
  };

  const generateSmartResponse = (message) => {
    const msg = message.toLowerCase();
    const currentLang = getCurrentLanguage();
    const isDarijaText = isDarija(message);

    // Analyser l'historique pour des réponses contextuelles
    const lastExchange = conversationHistory[conversationHistory.length - 1];
    const hasRecentContext = lastExchange && 
      (new Date() - lastExchange.timestamp) < 300000; // 5 minutes

    // إذا كان النص بالدارجة، نفهمه لكن نرد بالفصحى
    if (isDarijaText) {
      // خدمات
      if (msg.includes('خدمة') || msg.includes('خدمات') || msg.includes('واش عندكم') || msg.includes('شحال عندكم')) {
        return 'تقدم الغرفة الجزائرية للتجارة والصناعة خدمات متنوعة: المساعدة الإدارية والقانونية، قاعدة البيانات الاقتصادية، الوساطة والتحكيم التجاري، والتكوين المهني. 📋 اتصلوا بنا على الرقم 023161631 للمزيد من المعلومات!';
      }

      // تواصل
      if (msg.includes('تواصل') || msg.includes('وين راكم') || msg.includes('العنوان') || msg.includes('التلفون') || msg.includes('كيفاش نوصل')) {
        return 'يقع مقر الغرفة الجزائرية للتجارة والصناعة في القصر القنصلي، 6 شارع أميلكار كابرال، ساحة الشهداء، الجزائر العاصمة. 📍 هاتف: 023161631 / 023160534 📞 بريد إلكتروني: infos-caci@caci.dz ✉️ نرحب بزيارتكم!';
      }

      // منصات
      if (msg.includes('موقع') || msg.includes('منصة') || msg.includes('مواقع') || msg.includes('انترنت')) {
        return 'لدينا عدة منصات إلكترونية: ElMouchir لدليل الشركات، EC للتجارة الإلكترونية، BC لمركز الأعمال، Formations للتكوين وغيرها من الخدمات! 💻 يمكنكم زيارة موقعنا الرئيسي للوصول إلى جميع المنصات.';
      }

      // شركات
      if (msg.includes('شركة') || msg.includes('مؤسسة') || msg.includes('تجارة') || msg.includes('نخدم معاكم')) {
        return 'نحن نساعد جميع الشركات في الجزائر، الكبيرة والصغيرة على حد سواء! 🏢 نقدم لكم الاستشارة والمرافقة والتكوين. ما هي احتياجات شركتكم المحددة؟';
      }

      // تكوين
      if (msg.includes('تكوين') || msg.includes('تدريب') || msg.includes('تعليم') || msg.includes('دروس')) {
        return 'نقدم برامج تكوين متخصصة وعالية الجودة للمهنيين والشركات! 🎓 يمكنكم زيارة منصة formations.caci.dz للاطلاع على البرامج المتاحة أو الاتصال بنا للمزيد من المعلومات.';
      }

      // أسعار
      if (msg.includes('سعر') || msg.includes('شحال') || msg.includes('فلوس') || msg.includes('تكلفة')) {
        return 'تختلف الأسعار حسب نوع الخدمة المطلوبة. 💰 نقدم خيارات مناسبة لجميع الميزانيات. يرجى الاتصال بنا على 023161631 للحصول على تفاصيل الأسعار!';
      }

      // كيفية الوصول
      if (msg.includes('كيفاش') && (msg.includes('نوصل') || msg.includes('نستفيد') || msg.includes('نخدم'))) {
        return 'يمكنكم الاستفادة من خدماتنا بالطرق التالية: 1️⃣ الاتصال بنا على 023161631 2️⃣ زيارة مكاتبنا في القصر القنصلي 3️⃣ تصفح منصاتنا الإلكترونية. فريقنا مستعد لخدمتكم! 🤝';
      }

      // أسئلة أخرى
      if (msg.includes('أخرى') || msg.includes('زادة') || msg.includes('تاني') || msg.includes('كاش حاجة')) {
        return 'بالطبع! نقدم أيضاً: الوساطة التجارية، الاستشارات القانونية، تنظيم المعارض والفعاليات الاقتصادية، وخدمات التصديق على الوثائق. 😊 ما الذي يهمكم أكثر؟';
      }

      // رد افتراضي للدارجة (بالفصحى)
      return 'أهلاً وسهلاً بكم! 😊 أنا هنا لمساعدتكم في أمور الغرفة الجزائرية للتجارة والصناعة. نحن نمثل مصالح الشركات في الجزائر ونقدم خدمات متنوعة لدعم الاقتصاد الوطني. ما الذي تودون معرفته تحديداً؟';
    }

    // الباقي من الكود للغات الأخرى...
    // Réponses contextuelles basées sur l'historique
    if (hasRecentContext) {
      const lastUserMessage = lastExchange.user.toLowerCase();
      const lastAssistantMessage = lastExchange.assistant.toLowerCase();

      // Si la question précédente était sur les services et maintenant demande "comment"
      if (lastUserMessage.includes('service') && (msg.includes('comment') || msg.includes('how') || msg.includes('كيف'))) {
        return currentLang === 'ar'
          ? 'للاستفادة من خدماتنا: 1️⃣ اتصلوا بنا على 023161631 2️⃣ زوروا مكاتبنا في القصر القنصلي 3️⃣ أو تصفحوا منصاتنا الإلكترونية. فريقنا جاهز لمساعدتكم!'
          : currentLang === 'en'
          ? 'To access our services: 1️⃣ Call us at 023161631 2️⃣ Visit our offices at PALAIS CONSULAIRE 3️⃣ Or browse our online platforms. Our team is ready to help you!'
          : 'Pour accéder à nos services : 1️⃣ Appelez-nous au 023161631 2️⃣ Visitez nos bureaux au PALAIS CONSULAIRE 3️⃣ Ou consultez nos plateformes en ligne. Notre équipe est prête à vous aider !';
      }

      // Si la question précédente était sur les plateformes et maintenant demande des détails
      if (lastUserMessage.includes('plateforme') && (msg.includes('détail') || msg.includes('plus') || msg.includes('details') || msg.includes('تفاصيل'))) {
        return currentLang === 'ar'
          ? 'تفاصيل منصاتنا: 📋 ElMouchir: دليل شامل للشركات 🛒 EC: منصة التجارة الإلكترونية 🏢 BC: مركز الأعمال 🎓 Formations: التكوين المهني. أي منصة تهمكم أكثر؟'
          : currentLang === 'en'
          ? 'Platform details: 📋 ElMouchir: Comprehensive business directory 🛒 EC: E-commerce platform 🏢 BC: Business center 🎓 Formations: Professional training. Which platform interests you most?'
          : 'Détails des plateformes : 📋 ElMouchir : Annuaire complet des entreprises 🛒 EC : Plateforme e-commerce 🏢 BC : Centre d\'affaires 🎓 Formations : Formation professionnelle. Quelle plateforme vous intéresse le plus ?';
      }

      // Si demande de prix après avoir parlé de formation
      if (lastAssistantMessage.includes('formation') && (msg.includes('prix') || msg.includes('coût') || msg.includes('price') || msg.includes('cost') || msg.includes('سعر'))) {
        return currentLang === 'ar'
          ? 'أسعار التكوين تختلف حسب البرنامج والمدة. 💰 لدينا خيارات مناسبة لجميع الميزانيات. اتصلوا بنا على 023161631 للحصول على عروض مخصصة أو زوروا formations.caci.dz'
          : currentLang === 'en'
          ? 'Training prices vary by program and duration. 💰 We have options for all budgets. Call us at 023161631 for customized quotes or visit formations.caci.dz'
          : 'Les prix de formation varient selon le programme et la durée. 💰 Nous avons des options pour tous les budgets. Appelez-nous au 023161631 pour des devis personnalisés ou visitez formations.caci.dz';
      }
    }

    // Questions de suivi courantes
    if (msg.includes('autre') || msg.includes('also') || msg.includes('else') || msg.includes('أخرى') || msg.includes('أيضا')) {
      return currentLang === 'ar'
        ? 'بالطبع! 😊 نقدم أيضاً: الوساطة التجارية، الاستشارات القانونية، تنظيم المعارض والأحداث الاقتصادية، وخدمات التصديق على الوثائق. ما الذي يهمكم أكثر؟'
        : currentLang === 'en'
        ? 'Of course! 😊 We also offer: Commercial mediation, legal consulting, organizing exhibitions and economic events, and document certification services. What interests you most?'
        : 'Bien sûr ! 😊 Nous offrons aussi : Médiation commerciale, conseils juridiques, organisation d\'expositions et événements économiques, et services de certification de documents. Qu\'est-ce qui vous intéresse le plus ?';
    }

    // Questions originales (services, contact, etc.) - code existant
    if (msg.includes('service') || msg.includes('خدمة') || msg.includes('خدمات')) {
      return currentLang === 'ar' 
        ? 'تقدم الغرفة الجزائرية للتجارة والصناعة خدمات متنوعة: المساعدة الإدارية والقانونية، قاعدة البيانات الاقتصادية، الوساطة والتحكيم، والتكوين المهني! 📋 اتصلوا بنا على 023161631 للمزيد من التفاصيل.'
        : currentLang === 'en'
        ? 'CACI offers diverse services: administrative and legal assistance, economic database, mediation and arbitration, and professional training! 📋 Contact us at 023161631 for more details.'
        : 'La CACI offre des services variés : assistance administrative et juridique, base de données économiques, médiation et arbitrage, et formation professionnelle! 📋 Contactez-nous au 023161631 pour plus de détails.';
    }

    if (msg.includes('contact') || msg.includes('téléphone') || msg.includes('adresse') || msg.includes('تواصل') || msg.includes('عنوان')) {
      return currentLang === 'ar'
        ? 'عنوان الغرفة: القصر القنصلي 6 شارع أميلكار كابرال، ساحة الشهداء، الجزائر العاصمة 📍 الهاتف: 023161631 / 023160534 📞 البريد الإلكتروني: infos-caci@caci.dz ✉️'
        : currentLang === 'en'
        ? 'CACI Address: PALAIS CONSULAIRE 6 BD AMILCAR CABRAL, PLACE DES MARTYRS, Algiers 📍 Phone: 023161631 / 023160534 📞 Email: infos-caci@caci.dz ✉️'
        : 'Adresse CACI : PALAIS CONSULAIRE 6 BD AMILCAR CABRAL, PLACE DES MARTYRS, Alger 📍 Téléphone : 023161631 / 023160534 📞 Email : infos-caci@caci.dz ✉️';
    }

    if (msg.includes('plateforme') || msg.includes('site') || msg.includes('elmouchir') || msg.includes('منصة') || msg.includes('موقع')) {
      return currentLang === 'ar'
        ? 'لدينا عدة منصات: ElMouchir لدليل الشركات، EC للتجارة الإلكترونية، BC لمركز الأعمال، Formations للتكوين، وغيرها! 💻 زوروا موقعنا الرئيسي للوصول إلى جميع المنصات.'
        : currentLang === 'en'
        ? 'We have several platforms: ElMouchir for business directory, EC for e-commerce, BC for business center, Formations for training, and more! 💻 Visit our main website to access all platforms.'
        : 'Nous avons plusieurs plateformes : ElMouchir pour l\'annuaire des entreprises, EC pour l\'e-commerce, BC pour le centre d\'affaires, Formations pour la formation, et plus! 💻 Visitez notre site principal pour accéder à toutes les plateformes.';
    }

    if (msg.includes('entreprise') || msg.includes('société') || msg.includes('business') || msg.includes('شركة') || msg.includes('مؤسسة')) {
      return currentLang === 'ar'
        ? 'نساعد الشركات في جميع القطاعات من خلال الاستشارة والمرافقة والتكوين! 🏢 نقدم الدعم الإداري والقانوني وتسهيل العلاقات التجارية. كيف يمكننا مساعدة شركتكم؟'
        : currentLang === 'en'
        ? 'We help businesses in all sectors through consulting, support and training! 🏢 We provide administrative and legal support and facilitate business relations. How can we help your company?'
        : 'Nous aidons les entreprises de tous secteurs à travers le conseil, l\'accompagnement et la formation! 🏢 Nous fournissons un soutien administratif et juridique et facilitons les relations d\'affaires. Comment pouvons-nous aider votre entreprise?';
    }

    if (msg.includes('formation') || msg.includes('training') || msg.includes('تكوين') || msg.includes('تدريب')) {
      return currentLang === 'ar'
        ? 'نقدم برامج تكوين متخصصة للمهنيين والشركات! 🎓 زوروا منصة formations.caci.dz للاطلاع على البرامج المتاحة أو اتصلوا بنا للمزيد من المعلومات.'
        : currentLang === 'en'
        ? 'We offer specialized training programs for professionals and companies! 🎓 Visit formations.caci.dz to see available programs or contact us for more information.'
        : 'Nous proposons des programmes de formation spécialisés pour les professionnels et entreprises! 🎓 Visitez formations.caci.dz pour voir les programmes disponibles ou contactez-nous pour plus d\'informations.';
    }

    // Default response
    return currentLang === 'ar'
      ? 'شكراً لسؤالكم! 😊 أنا هنا لمساعدتكم بمعلومات حول الغرفة الجزائرية للتجارة والصناعة. نحن نمثل مصالح الشركات في الجزائر ونقدم خدمات متنوعة لدعم الاقتصاد الوطني. ماذا تودون معرفته تحديداً؟'
      : currentLang === 'en'
      ? 'Thank you for your question! 😊 I\'m here to help you with information about the Algerian Chamber of Commerce and Industry. We represent business interests in Algeria and provide various services to support the national economy. What specifically would you like to know?'
      : 'Merci pour votre question! 😊 Je suis là pour vous aider avec des informations sur la Chambre Algérienne de Commerce et d\'Industrie. Nous représentons les intérêts des entreprises en Algérie et offrons divers services pour soutenir l\'économie nationale. Que souhaitez-vous savoir spécifiquement?';
  };

  // Initialize welcome message
  useEffect(() => {
    const lang = getCurrentLanguage();
    let welcomeText;
    
    // رسالة ترحيب متعددة اللغات مع إضافة الدارجة
    if (lang === 'ar') {
      welcomeText = 'مرحباً بكم في الغرفة الجزائرية للتجارة والصناعة! 👋 أنا مساعدكم الذكي. يمكنني مساعدتكم بمعلومات حول خدماتنا ومنصاتنا وكيف يمكننا دعم أعمالكم. ماذا تودون معرفته؟';
    } else if (lang === 'en') {
      welcomeText = 'Welcome to the Algerian Chamber of Commerce and Industry! 👋 I\'m your AI assistant. I can help you with information about our services, platforms, and how we can support your business. What would you like to know?';
    } else {
      // الفرنسية مع إشارة للدارجة
      welcomeText = 'Bienvenue à la Chambre Algérienne de Commerce et d\'Industrie! 👋 Je suis votre assistant IA. Je peux vous aider avec des informations sur nos services, nos plateformes et comment nous pouvons soutenir votre entreprise. Vous pouvez me parler en français, arabe ou darija algérienne! Que souhaitez-vous savoir?';
    }

    const welcomeMessage = {
      id: 1,
      text: welcomeText,
      sender: 'bot',
      timestamp: new Date()
    };
    
    setMessages([welcomeMessage]);
    
    // Réinitialiser l'historique de conversation au démarrage
    setConversationHistory([]);
  }, []);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const addMessage = (text, sender) => {
    const newMessage = {
      id: Date.now(),
      text,
      sender,
      timestamp: new Date()
    };
    setMessages(prev => [...prev, newMessage]);
  };

  const handleSendMessage = async () => {
    if (!inputMessage.trim() || isTyping) return;

    const userMessage = inputMessage.trim();
    addMessage(userMessage, 'user');
    setInputMessage('');
    setIsTyping(true);

    try {
      // Essayer d'abord l'API Groq
      const response = await callGroqAPI(userMessage);
      addMessage(response, 'bot');
    } catch (error) {
      console.error('API Error:', error);
      // Fallback vers les réponses intelligentes locales
      const fallbackResponse = generateSmartResponse(userMessage);
      addMessage(fallbackResponse, 'bot');
    } finally {
      setIsTyping(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  const quickActions = [
    {
      key: 'services',
      text: {
        fr: '🏢 Nos Services',
        ar: '🏢 خدماتنا',
        en: '🏢 Our Services',
        dz: '🏢 الخدمات' // مبسط للدارجة
      },
      message: {
        fr: 'Quels sont les services offerts par la CACI?',
        ar: 'ما هي الخدمات التي تقدمها الغرفة الجزائرية للتجارة والصناعة؟',
        en: 'What services does CACI offer?',
        dz: 'واش هي الخدمات اللي تقدموها؟' // دارجة لكن الرد سيكون بالفصحى
      }
    },
    {
      key: 'contact',
      text: {
        fr: '📞 Contact',
        ar: '📞 التواصل',
        en: '📞 Contact',
        dz: '📞 التواصل'
      },
      message: {
        fr: 'Comment puis-je contacter la CACI?',
        ar: 'كيف يمكنني التواصل مع الغرفة؟',
        en: 'How can I contact CACI?',
        dz: 'كيفاش نتواصل معاكم؟' // دارجة لكن الرد سيكون بالفصحى
      }
    },
    {
      key: 'platforms',
      text: {
        fr: '💻 Plateformes',
        ar: '💻 المنصات',
        en: '💻 Platforms',
        dz: '💻 المواقع'
      },
      message: {
        fr: 'Quelles sont vos plateformes en ligne?',
        ar: 'ما هي منصاتكم الإلكترونية؟',
        en: 'What are your online platforms?',
        dz: 'واش هي المواقع الإلكترونية نتوعكم؟' // دارجة لكن الرد سيكون بالفصحى
      }
    }
  ];

  // تحديد اللغة بناءً على المحتوى (تعديل للتعامل مع الدارجة)
  const detectLanguageFromContent = (text) => {
    if (isDarija(text)) return 'dz'; // نتعرف على الدارجة
    if (text.match(/[ا-ي]/)) return 'ar';
    if (text.match(/[a-zA-Z]/)) {
      // تمييز بين الفرنسية والإنجليزية
      const frenchWords = ['le', 'la', 'les', 'de', 'des', 'du', 'et', 'à', 'dans', 'pour', 'avec', 'sur', 'par', 'comment', 'quoi', 'que', 'qui'];
      const englishWords = ['the', 'and', 'or', 'but', 'in', 'on', 'at', 'to', 'for', 'of', 'with', 'by', 'how', 'what', 'that', 'who'];
      
      const lowerText = text.toLowerCase();
      const frenchCount = frenchWords.filter(word => lowerText.includes(word)).length;
      const englishCount = englishWords.filter(word => lowerText.includes(word)).length;
      
      return frenchCount > englishCount ? 'fr' : 'en';
    }
    return getCurrentLanguage();
  };

  const currentLang = getCurrentLanguage();

  return (
    <div className="caci-chatbot-wrapper" style={{ display: 'none' }}>
      {/* Floating Action Button */}
      <div className="chatbot-fab" onClick={() => setIsOpen(!isOpen)}>
        <i className={`bi bi-${isOpen ? 'x' : 'chat-dots'}`}></i>
        {showNotification && !isOpen && (
          <div className="notification-badge">1</div>
        )}
      </div>

      {/* Chatbot Container */}
      {isOpen && (
        <div className="chatbot-container">
          {/* Header */}
          <div className="chatbot-header">
            <div className="chatbot-title">
              <div className="chatbot-avatar">
                <i className="bi bi-building"></i>
              </div>
              <div className="chatbot-info">
                <h6>CACI Assistant</h6>
                <div className="status">
                  <div className="status-dot"></div>
                  <span>
                    {currentLang === 'ar' ? 'متاح 24/7' : 
                     currentLang === 'en' ? 'Available 24/7' : 
                     'Disponible 24/7'}
                  </span>
                </div>
              </div>
            </div>
            <button 
              className="close-btn" 
              onClick={() => {
                setIsOpen(false);
                setShowNotification(false);
              }}
            >
              <i className="bi bi-x"></i>
            </button>
          </div>

          {/* Messages */}
          <div className="chatbot-messages">
            {messages.map((message) => (
              <div key={message.id} className={`message ${message.sender}`}>
                <div className="message-avatar">
                  <i className={`bi bi-${message.sender === 'user' ? 'person' : 'building'}`}></i>
                </div>
                <div className="message-content">
                  <p className="message-text">{message.text}</p>
                  <div className="message-time">{formatTime(message.timestamp)}</div>
                </div>
              </div>
            ))}

            {/* Quick Actions */}
            {messages.length === 1 && (
              <div className="quick-actions">
                {quickActions.map((action) => {
                  const displayLang = detectLanguageFromContent(inputMessage) || currentLang;
                  const actionText = action.text[displayLang] || action.text[currentLang] || action.text.fr;
                  const actionMessage = action.message[displayLang] || action.message[currentLang] || action.message.fr;
                  
                  return (
                    <button
                      key={action.key}
                      className="quick-action"
                      onClick={async () => {
                        addMessage(actionMessage, 'user');
                        setIsTyping(true);
                        try {
                          const response = await callGroqAPI(actionMessage);
                          addMessage(response, 'bot');
                        } catch (error) {
                          const fallbackResponse = generateSmartResponse(actionMessage);
                          addMessage(fallbackResponse, 'bot');
                        } finally {
                          setIsTyping(false);
                        }
                      }}
                    >
                      {actionText}
                    </button>
                  );
                })}
              </div>
            )}

            {/* Typing Indicator */}
            {isTyping && (
              <div className="message bot">
                <div className="message-avatar">
                  <i className="bi bi-building"></i>
                </div>
                <div className="typing-indicator">
                  <div className="typing-dots">
                    <div className="typing-dot"></div>
                    <div className="typing-dot"></div>
                    <div className="typing-dot"></div>
                  </div>
                </div>
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>

          {/* Input Area */}
          <div className="chatbot-input-area">
            <div className="input-container">
              <textarea
                value={inputMessage}
                onChange={(e) => setInputMessage(e.target.value)}
                onKeyDown={handleKeyPress}
                placeholder={
                  currentLang === 'ar' ? 'اكتب رسالتك هنا...' :
                  currentLang === 'en' ? 'Type your message here...' :
                  'Tapez votre message ici...'
                }
                className="message-input"
                rows="1"
                style={{ resize: 'none' }}
              />
              <button 
                className="send-btn" 
                onClick={handleSendMessage}
                disabled={!inputMessage.trim() || isTyping}
              >
                <i className="bi bi-send"></i>
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .caci-chatbot-wrapper {
          position: fixed;
          bottom:80px;
          right: 20px;
          z-index: 1000;
          font-family: inherit;
        }

        .chatbot-fab {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: linear-gradient(135deg, #28a745, #1e7e34);
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 4px 20px rgba(40, 167, 69, 0.4);
          transition: all 0.3s ease;
          position: relative;
        }

        .chatbot-fab:hover {
          transform: scale(1.1);
          box-shadow: 0 6px 25px rgba(40, 167, 69, 0.6);
        }

        .chatbot-fab i {
          font-size: 1.5rem;
        }

        .notification-badge {
          position: absolute;
          top: -5px;
          right: -5px;
          background: #dc3545;
          color: white;
          border-radius: 50%;
          width: 20px;
          height: 20px;
          font-size: 0.7rem;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          animation: pulse 2s infinite;
        }

        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.1); }
          100% { transform: scale(1); }
        }

        .chatbot-container {
          position: absolute;
          bottom: 80px;
          right: 0;
          width: 380px;
          height: 600px;
          background: white;
          border-radius: 20px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
          display: flex;
          flex-direction: column;
          overflow: hidden;
          animation: slideIn 0.3s ease;
        }

        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(20px) scale(0.9);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        .chatbot-header {
          background: linear-gradient(135deg, #28a745, #1e7e34);
          color: white;
          padding: 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .chatbot-title {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .chatbot-avatar {
          width: 40px;
          height: 40px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.2rem;
        }

        .chatbot-info h6 {
          margin: 0;
          font-weight: 700;
          font-size: 1rem;
        }

        .status {
          font-size: 0.8rem;
          opacity: 0.9;
          display: flex;
          align-items: center;
          gap: 5px;
        }

        .status-dot {
          width: 8px;
          height: 8px;
          background: #10b981;
          border-radius: 50%;
          animation: pulse 2s infinite;
        }

        .close-btn {
          background: none;
          border: none;
          color: white;
          font-size: 1.2rem;
          cursor: pointer;
          opacity: 0.8;
          transition: opacity 0.3s ease;
          padding: 5px;
          border-radius: 50%;
        }

        .close-btn:hover {
          opacity: 1;
          background: rgba(255, 255, 255, 0.1);
        }

        .chatbot-messages {
          flex: 1;
          padding: 20px;
          overflow-y: auto;
          background: #f8f9fa;
        }

        .message {
          display: flex;
          gap: 10px;
          margin-bottom: 15px;
          align-items: flex-start;
        }

        .message.user {
          flex-direction: row-reverse;
        }

        .message-avatar {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.9rem;
          flex-shrink: 0;
        }

        .message.bot .message-avatar {
          background: linear-gradient(135deg, #28a745, #1e7e34);
          color: white;
        }

        .message.user .message-avatar {
          background: #6c757d;
          color: white;
        }

        .message-content {
          max-width: 80%;
          background: white;
          border-radius: 18px;
          padding: 12px 16px;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        }

        .message.user .message-content {
          background: #28a745;
          color: white;
        }

        .message-text {
          font-size: 0.9rem;
          line-height: 1.4;
          margin: 0;
        }

        .message-time {
          font-size: 0.7rem;
          opacity: 0.6;
          margin-top: 5px;
        }

        .quick-actions {
          display: flex;
          flex-direction: column;
          gap: 8px;
          margin-top: 15px;
        }

        .quick-action {
          background: white;
          border: 1px solid #e9ecef;
          border-radius: 15px;
          padding: 12px 16px;
          font-size: 0.85rem;
          cursor: pointer;
          transition: all 0.3s ease;
          text-align: left;
        }

        .quick-action:hover {
          background: #28a745;
          color: white;
          border-color: #28a745;
          transform: translateY(-2px);
        }

        .typing-indicator {
          background: white;
          border-radius: 18px;
          padding: 12px 16px;
          display: flex;
          align-items: center;
        }

        .typing-dots {
          display: flex;
          gap: 4px;
          align-items: center;
        }

        .typing-dot {
          width: 8px;
          height: 8px;
          background: #6c757d;
          border-radius: 50%;
          animation: typing 1.4s infinite;
        }

        .typing-dot:nth-child(2) {
          animation-delay: 0.2s;
        }

        .typing-dot:nth-child(3) {
          animation-delay: 0.4s;
        }

        @keyframes typing {
          0%, 60%, 100% {
            transform: translateY(0);
          }
          30% {
            transform: translateY(-10px);
          }
        }

        .chatbot-input-area {
          padding: 20px;
          background: white;
          border-top: 1px solid #e9ecef;
        }

        .input-container {
          display: flex;
          gap: 10px;
          align-items: flex-end;
        }

        .message-input {
          flex: 1;
          background: #f8f9fa;
          border: 1px solid #e9ecef;
          border-radius: 25px;
          padding: 12px 18px;
          font-family: inherit;
          resize: none;
          max-height: 100px;
          min-height: 44px;
          transition: all 0.3s ease;
        }

        .message-input:focus {
          outline: none;
          border-color: #28a745;
          box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.1);
        }

        .send-btn {
          background: #28a745;
          color: white;
          border: none;
          border-radius: 50%;
          width: 44px;
          height: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s ease;
          flex-shrink: 0;
        }

        .send-btn:hover:not(:disabled) {
          background: #1e7e34;
          transform: scale(1.05);
        }

        .send-btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
          transform: none;
        }

        @media (max-width: 768px) {
          .chatbot-container {
            width: 100vw;
            height: 100vh;
            bottom: 0;
            right: 0;
            border-radius: 0;
            position: fixed;
          }
          
          .caci-chatbot-wrapper {
            bottom: 15px;
            right: 15px;
          }
          
          .chatbot-fab {
            width: 50px;
            height: 50px;
          }
          
          .chatbot-fab i {
            font-size: 1.2rem;
          }
        }

        .chatbot-messages::-webkit-scrollbar {
          width: 6px;
        }

        .chatbot-messages::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }

        .chatbot-messages::-webkit-scrollbar-thumb {
          background: #28a745;
          border-radius: 10px;
        }

        .chatbot-messages::-webkit-scrollbar-thumb:hover {
          background: #1e7e34;
        }
      `}</style>
    </div>
  );
};

export default CACIChatbot;